import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  location_container: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  text: {
    fontSize: "14px",
    fontWeight: 600,
    margin: 0,
  },
  title: {
    fontSize: "12px",
    color: theme.palette.grey["600"],
    fontWeight: 800,
    marginBottom: "4px",
  },
}))

export { useStyles }
